import { Loader2, X } from "lucide-react";
import type { ReactNode } from "react";

export const inputCls =
  "w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[var(--hmg-red)]";
export const inputDisabledCls = "w-full rounded-lg border border-slate-200 px-3 py-2 bg-slate-50 text-slate-500";
export const btnPrimary =
  "rounded-lg bg-[var(--hmg-red)] hover:bg-[var(--hmg-red-dark)] text-white text-sm font-semibold px-4 py-2 inline-flex items-center gap-2 disabled:opacity-60";
export const btnSecondary =
  "rounded-lg bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 text-sm font-semibold px-4 py-2 inline-flex items-center gap-2 disabled:opacity-50";

export function Spinner({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <div className="flex justify-center py-12">
      <Loader2 className={`${className} animate-spin text-[var(--hmg-red)]`} />
    </div>
  );
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>
      {children}
    </div>
  );
}

export function Modal({
  title,
  subtitle,
  onClose,
  children,
  size = "md",
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  size?: "sm" | "md" | "lg";
}) {
  const w = size === "sm" ? "max-w-sm" : size === "lg" ? "max-w-lg" : "max-w-md";
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50" role="dialog" aria-modal="true">
      <div className={`bg-white rounded-xl shadow-xl ${w} w-full p-6 max-h-[90vh] overflow-y-auto`}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold inline-flex items-center gap-2">{title}</h2>
            {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
          </div>
          <button type="button" onClick={onClose} className="p-1 hover:bg-slate-100 rounded" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function ErrorBox({ children }: { children: ReactNode }) {
  return <div className="text-sm text-red-700 bg-red-50 border border-red-200 p-2 rounded">{children}</div>;
}

export function Forbidden() {
  return <div className="rounded-xl bg-red-50 border border-red-200 p-6 text-red-700">You need Super Admin access to view this page.</div>;
}
